import React from "react";
import * as S from "./styles";
import LazyLoad from "react-lazyload";

export default ({ code, width, height, url, ...rest }) => {
  console.log(code);
  return (
    <S.Placeholder width={width} height={height}>
      <LazyLoad offset={150} once placeholder={<div />}>
        <div dangerouslySetInnerHTML={{ __html: code }} {...rest} key={url} />
      </LazyLoad>
    </S.Placeholder>
  );
};
